// Requests/Reschedule_Slot.ts
import { getAccessToken } from "../Services/authToken";
export interface RescheduleSlotResponse {
  success: boolean;
  message: string;
  scheduled_date?: string;
  scheduled_start_time?: string;
  scheduled_end_time?: string;
  interviewer_name?: string;
  requisition_name?: string;
}

const hostname = window.location.hostname;


export async function rescheduleInterviewSlot(candidateEmail: string, slotId: string, reason: string): Promise<RescheduleSlotResponse> 
{
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl= 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com'; // fallback production
  }

  // GET TOKEN
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Authentication required - please log in');
  }

  console.log(candidateEmail, slotId, "inside reschedule slot");
  const res = await fetch(`${baseurl}/api/candidate-dashboard/reschedule-slot`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' ,'Authorization': `Bearer ${token}`},
    // body: JSON.stringify({  slotId, reason }),
    body: JSON.stringify({ slotId, cancellation_reason: reason }),
  });
  if (!res.ok) throw new Error(`Reschedule failed: ${res.status} ${res.statusText}`);
  return res.json();
}

export async function rescheduleInterviewSlotExp(candidateEmail: string, slotId: string, reason: string): Promise<RescheduleSlotResponse> 
{
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  const token = await getAccessToken();
  if (!token) {
    throw new Error('Authentication required - please log in');
  }

  console.log(candidateEmail, slotId, "inside reschedule slot exp");
  const res = await fetch(`${baseurl}/api/candidate-dashboard/reschedule-slot-exp`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    body: JSON.stringify({ slotId, cancellation_reason: reason }),
  });
  if (!res.ok) throw new Error(`Reschedule failed: ${res.status} ${res.statusText}`);
  return res.json();
}


export async function sendRescheduleEmail(slot: any, candidateEmail: string, reason: string, isExperienced: boolean, isCampus: boolean) 
{
  let baseurl = '';
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl= 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com'; // fallback production
  }

  // GET TOKEN
  const token = await getAccessToken();
  if (!token) {
    throw new Error('Authentication required - please log in');
  }
 
  // Get the reqid and job title from the slot
  const reqId = slot?.pairing?.requisition_id || slot?.requisition_id || 'N/A';
  const jobTitleRaw = slot?.job_title || 'N/A';
  const jobTitle = `${reqId} ${jobTitleRaw}`;

  const recruiterEmail = slot?.pairing?.recruiter_email; 
  const recruiterName = slot?.pairing?.recruiter_name; 
  
  // Build interviewer slots with validation
  const interviewerSlots = [
    {
      interviewer_email: slot?.pairing?.interviewer_1_id,
      interviewer_name: slot?.pairing?.interviewer_1_name,
      start_time: slot?.pairing?.interview_1_start_time
        ? new Date(slot.pairing.interview_1_start_time).toISOString()
        : null,
      end_time: slot?.pairing?.interview_1_end_time
        ? new Date(slot.pairing.interview_1_end_time).toISOString()
        : null,
      interview_type: slot?.pairing?.interview_1_type ?? null,
    },
    {
      interviewer_email: slot?.pairing?.interviewer_2_id,
      interviewer_name: slot?.pairing?.interviewer_2_name,
      start_time: slot?.pairing?.interview_2_start_time
        ? new Date(slot.pairing.interview_2_start_time).toISOString()
        : null,
      end_time: slot?.pairing?.interview_2_end_time
        ? new Date(slot.pairing.interview_2_end_time).toISOString()
        : null,
      interview_type: slot?.pairing?.interview_2_type ?? null,
    },
    {
      interviewer_email: slot?.pairing?.interviewer_3_id,
      interviewer_name: slot?.pairing?.interviewer_3_name,
      start_time: slot?.pairing?.interview_3_start_time
        ? new Date(slot.pairing.interview_3_start_time).toISOString()
        : null,
      end_time: slot?.pairing?.interview_3_end_time
        ? new Date(slot.pairing.interview_3_end_time).toISOString()
        : null,
      interview_type: slot?.pairing?.interview_3_type ?? null,
    },
  ].filter(s => s.interviewer_email && s.interviewer_name);

  // Validate required fields before sending
  const candidateName = slot?.pairing?.candidate_full_name;
  // const jobTitle = slot?.job_title;
  const interviewDate = slot?.pairing?.start_time 
    ? new Date(slot.pairing.start_time).toISOString().split('T')[0] 
    : null;

  // Log for debugging
  console.log('[sendRescheduleEmail] Validation check:', {
    candidateName,
    jobTitle,
    interviewDate,
    interviewerSlotsCount: interviewerSlots.length,
    recruiterEmail,
  });

  // Skip email if required data is missing
  if (!candidateName || !jobTitle || interviewerSlots.length === 0) {
    console.warn('[sendRescheduleEmail] Skipping email - missing required data:', {
      hasCandidateName: !!candidateName,
      hasJobTitle: !!jobTitle,
      hasInterviewerSlots: interviewerSlots.length > 0,
    });
    return { success: false, message: 'Missing required data for reschedule email' };
  }

  const payload = {
    email_type: "interview_reschedule",
    additional_data: {
      candidate_email: candidateEmail,
      candidate_name: candidateName,
      job_title: jobTitle,
      interviewer_slots: interviewerSlots,
      interview_date: interviewDate,
      reschedule_reason: reason,
      send_to_candidate: false,
      send_to_interviewers: true,
      send_to_recruiter: true,
      recruiter_email: recruiterEmail,
      recruiter_name: recruiterName,
      campus_hire: isCampus,
      experienced_hire: isExperienced
    },
  };

  console.log('[sendRescheduleEmail] Payload:', JSON.stringify(payload, null, 2));
  
  const res = await fetch(`${baseurl}/api/communications/emails`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorBody = await res.text();
    console.error('[sendRescheduleEmail] Error response:', errorBody);
    throw new Error(`Email send failed: ${res.statusText} - ${errorBody}`);
  }
  
  return res.json();
}